import { BROWSER_LIST } from '@source/utilities/browser-list';

/**
 * IE modal controller that decides when this modal is active.
 */
export const IEModalController = () => {
    if (BROWSER_LIST.isIE) {
        const modalName = 'ie-modal';
        const modal = document.querySelector(`#${modalName}`);

        modal?.setAttribute('active', '');
    }
};
